import _get from 'lodash/get';
import { Google, Pixall } from '../analytics/index.js';
import { getInventoryOwnerById } from '../utilities/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';

/**
 * @summary Sends Google and Pixall event for chatbot AI CTA click on vdp
 */
export function chatbotCTAClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId,
    linkText
  } = data;
  const pageName = _get(dataLayer, 'page.pageName', '');
  const inheritPageData = !['vdp'].includes(pageName);
  const inventory = getInventoryOwnerById(state, inventoryId);
  const vehicleData = googleInventoryTransformer(inventory, {
    target: 'vehicle',
    dataLayer
  }, inheritPageData);
  const eventData = {
    vehicle: {
      ...vehicleData
    }
  };
  Google.sendClickEvent({
    eventElement: 'my-kbb',
    eventResult: `chatbot::initiation::${linkText}`,
    eventNonInteractive: false,
    eventData
  }, option);
  Pixall.sendClickEvent({
    program: 'DealerDotCom',
    dealerCode: 'kbbcox',
    wspCode: 'KBB',
    pageType: 'owner',
    eventSource: 'userAccount',
    label: `chatbot::initiation::${linkText}`,
    feature: 'my-kbb',
    inventory
  }, dataLayer, option);
  return {};
}

/**
 * @summary Google impression for chatbot AI on vdp
 */
export function chatbotImpression(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId,
    siteArea
  } = data;
  const pageName = _get(dataLayer, 'page.pageName', '');
  const inheritPageData = !['vdp'].includes(pageName);
  const inventory = getInventoryOwnerById(state, inventoryId);
  const vehicleData = googleInventoryTransformer(inventory, {
    target: 'vehicle',
    dataLayer
  }, inheritPageData);
  const eventData = {
    vehicle: {
      ...vehicleData
    }
  };
  Google.sendImpressions(metadata, {
    eventElement: 'my-kbb',
    eventResult: `chatbot::text::${siteArea}`,
    eventNonInteractive: false,
    eventData
  }, option);
  Pixall.sendImpression(metadata, {
    program: 'DealerDotCom',
    dealerCode: 'kbbcox',
    wspCode: 'KBB',
    pageType: 'owner',
    eventSource: 'userAccount',
    eventType: 'loaded',
    label: `chatbot::text::${siteArea}`,
    feature: 'my-kbb'
  }, option);
  return {};
}
export default {
  chatbotCTAClick,
  chatbotImpression
};